// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3R46I","title":"BackImages_title__oh3Ao","images":"BackImages_images__r9ZpV"};